import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { api } from '../../settings/env';

export default function NotificationsPage() {

  const [citas, setCitas] = useState(false);
  useEffect(() => {
    const id = localStorage.getItem("vitaly_userid");

    const data = {
      "day": "",
      "month": "",
      "year": ""
    }

    axios.post(`${api}/appoinments/${id}`, data)
      .then(response => {
        console.log("Cita registrada", response.data);
        setCitas(response.data);

        response.data.map(el => {

          if (el.status != "Confirmado") {
            return
          }

          const div = document.getElementById(el.time)

          console.log("Soy ", el.time, div)

          if (div) {
            div.innerText = el.full_name;
            div.style.background = "#7183ffb8"
          }
        })
      })
      .catch(error => {
        console.log("Error al registrar la cita", error);
      });
  }, [])


  function convertirHoraMilitarACivil(horaMilitar) {
    // Dividir la hora en horas y minutos
    const [horas, minutos] = horaMilitar.split(':').map(Number);

    // Determinar AM o PM
    const ampm = horas >= 12 ? 'PM' : 'AM';

    // Convertir horas a formato de 12 horas
    let horasCivil = horas % 12;
    horasCivil = horasCivil === 0 ? 12 : horasCivil; // 12 AM y 12 PM

    // Formatear la hora civil
    const horaCivil = `${horasCivil}:${String(minutos).padStart(2, '0')} ${ampm}`;

    return horaCivil;
  }

  const confirm = (id, cita) => {
    const newData = { 
      "professional_id": cita.professional_id, 
      "user_id": cita.user_id, 
      "month_code": cita.month_code, 
      "month_name": cita.month_name, 
      "time": cita.time, 
      "day": cita.day, 
      "year": cita.year, 
      "color": cita.color, 
      "status": "Confirmado", 
      "service": cita.service, 
      "first_date": cita.first_date, 
      "full_name": cita.full_name, 
      "ci_user": cita.ci_user, 
      "pay_method": cita.pay_method, 
      "pay_reference": "", 
      "pay_bank": "", 
      "pay_amount": 0.0, 
      "pay_phone": "", 
    }
    axios.put(`${api}/appoinments/edit/${id}`, newData)
      .then(resp => {
        console.log(resp.data)
      })
      .catch(err => console.log(err))
  }

  return (
    <div className='page-admin container my-4'>
      <h1>Solicitudes de citas</h1>
      <table className="table">
        <thead className='table-dark'>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Nombre</th>
            <th scope="col">Fecha</th>
            <th scope="col">Motivo</th>
            <th scope="col">Hora</th>
            <th scope="col">Acciones</th>
          </tr>
        </thead>
        <tbody>

          {
            citas && citas.map((cita, index) => {

              if (cita.status == "Por confirmar") {
                return (
                  <tr>
                    <th scope="row">
                      {index + 1}
                    </th>
                    <td>
                      {cita.full_name}
                    </td>
                    <td>
                      {`${cita.day} de ${cita.month_name} ${cita.year}`}
                    </td>
                    <td>
                      {cita.service}
                    </td>
                    <td>
                      {convertirHoraMilitarACivil(cita.time)}
                    </td>
                    <td>
                      <button
                        onClick={() => confirm(cita.id, cita)}
                        className='btn btn-info mx-4'
                      >
                        Aceptar
                      </button>

                      <button className='btn btn-danger'>Rechazar</button>
                    </td>
                  </tr>
                )
              }


            })
          }

        </tbody>
      </table>

    </div>
  )
}
